import alerts from "../shared/alerts";
import UserApi from "./../api/UserApi";

export default {
  getUserProfile: async () => {
    const response = await UserApi.getUserProfile();
    if (!response.success) {
      alerts.error("Error", response.message);
    }
    return response;
  },
  fetchUsersByFilter: async (values) => {
    const response = await UserApi.fetchUsersByFilter(values);
    if (!response.success) {
      alerts.error("Error", response.message);
    }
    if (response?.data?.length == 0) {
      alerts.warning("Usuarios", "No se encontraron registros");
    }
    return response;
  },
  updateUserWithAccess: async (values) => {
    const response = await UserApi.updateUserWithAccess(values);
    if (!response.success) {
      alerts.error("Error", response.message);
    } else {
      alerts.success("Usuario", "Actualizado con éxito");
    }
    return response;
  },
};
